<template>
  <div>
    <div class="flex flex-col gap-4">
      <PageSection
        disable-sticky-margin
        v-for="type in invoicingTypeList"
        :key="type"
        :title="$t('global.invoicing_type.' + type)"
      >
        <ul
          v-if="
            work.invoices?.filter((invoice) => invoice.doc_type === type)
              .length > 0
          "
          role="list"
          class="grid grid-cols-1 gap-4 sm:grid-cols-2"
        >
          <li
            v-for="(invoice, index) in work.invoices?.filter(
              (invoice) => invoice.doc_type === type
            )"
            :key="index"
          >
            <WorkFormInvoicingCard :invoice="invoice" />
          </li>
        </ul>
        <div v-else>
          {{
            $t('validation.there_is_no_yet_for_m', {
              settings: $t('global.invoicing_type.' + type),
              container: $t('attributes.work')
            })
          }}
        </div>
      </PageSection>
    </div>
  </div>
</template>

<script>
import WorkFormInvoicingCard from '@p/works/form/subpages/invoicing/components/WorkFormInvoicingCard'

import { mapGetters } from 'vuex'

export default {
  name: 'TheWorkInvoicingPage',
  components: { WorkFormInvoicingCard },
  data() {
    return { invoicingTypeList: ['INV', 'PO', 'QUO', 'CN'] }
  },
  computed: {
    ...mapGetters({
      work: 'work/getWork'
    })
  }
}
</script>
